export default "__VITE_ASSET__ziKW7qGk__"